<template>
  <div>
    <Head title="Strony nawigacji" />
    <h1 class="mb-2 text-3xl font-bold">
      Strony nawigacji
    </h1>
    <p class="mb-8 w-full text-sm text-gray-600">
      Katalog rekordów <code class="text-xs">pages</code> dostępnych w polach „strona docelowa”
      (nagłówek, stopka). Zarządzanie treścią odbywa się w sekcjach „Strony” i „Zasoby” w panelach witryn —
      tutaj tylko podgląd tego, co można podpiąć.
    </p>

    <p class="mb-4 text-sm text-gray-500">
      Łącznie: {{ total }} stron
    </p>

    <div class="overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm">
      <table class="min-w-full divide-y divide-gray-200 text-sm">
        <thead class="bg-gray-50">
          <tr>
            <th class="px-4 py-3 text-left font-semibold text-gray-700">
              Strona
            </th>
            <th class="px-4 py-3 text-left font-semibold text-gray-700">
              Kontekst
            </th>
            <th class="px-4 py-3 text-left font-semibold text-gray-700">
              Typ
            </th>
            <th class="px-4 py-3 text-left font-semibold text-gray-700">
              ID
            </th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-100">
          <tr v-for="page in pages" :key="page.id" class="hover:bg-gray-50">
            <td class="px-4 py-3">
              <span class="font-medium text-gray-900">{{ page.title || page.label }}</span>
              <span v-if="page.subtitle" class="mt-0.5 block text-xs text-gray-500">
                {{ page.subtitle }}
              </span>
            </td>
            <td class="px-4 py-3">
              <site-context-badge
                :tag="page.context_tag"
                :color-token="page.context_color"
              />
            </td>
            <td class="px-4 py-3 text-gray-600">
              {{ typeLabel(page) }}
            </td>
            <td class="px-4 py-3 text-gray-500">
              {{ page.id }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { Head } from '@inertiajs/vue3';
import SiteContextBadge from '@/Shared/SiteContextBadge.vue';
import { createLayoutHelper } from '@/utils/layoutHelper';

export default {
  components: { Head, SiteContextBadge },
  layout: createLayoutHelper,
  props: {
    pages: {
      type: Array,
      required: true,
    },
    total: {
      type: Number,
      required: true,
    },
  },
  methods: {
    typeLabel(page) {
      if (page.page_type === 'custom') return `Strona: ${page.slug}`;
      if (page.page_type === 'resource_index') return `Lista: ${page.resource_kind}`;
      return page.page_type;
    },
  },
};
</script>
